import { useMedia } from "../../context/MediaContext";
import { IonActionSheet } from "@ionic/react";
import React, { useEffect } from "react";

interface CameraActionSheetProps {
  showCameraOptions: boolean;
  setShowCameraOptions: (show: boolean) => void;
  tag: { type: string; detail: string };
  uploadPDF: () => void; // ahora viene del padre
}

const CameraActionSheet: React.FC<CameraActionSheetProps> = ({
  showCameraOptions,
  setShowCameraOptions,
  tag,
  uploadPDF, // recibimos la función desde el padre
}) => {
  const { takePhoto, currentMedia, setShowMediaState } = useMedia();

  useEffect(() => {
    // lógica adicional según currentMedia si se necesita
  }, [currentMedia]);

  return (
    <IonActionSheet
      isOpen={showCameraOptions}
      onDidDismiss={() => setShowCameraOptions(false)}
      buttons={[
        {
          text: "📸 Tomar Foto",
          handler: () => {
            setShowCameraOptions(false);
            takePhoto("CAMERA", tag); // usa la cámara
          },
        },
        {
          text: "🖼️ Seleccionar de Galería",
          handler: () => {
            setShowCameraOptions(false);
            takePhoto("GALLERY", tag); // selecciona de galería
          },
        },
        {
          text: "📄 Seleccionar PDF",
          handler: () => {
            setShowCameraOptions(false);
            uploadPDF(); // dispara el input oculto
          },
        },
        ...(currentMedia.length
          ? [
              {
                text: `🖼️ Ver archivos adjuntos (${currentMedia.length})`,
                handler: () => {
                  setShowCameraOptions(false);
                  setShowMediaState("gallery");
                },
              },
            ]
          : []),
        {
          text: "Cancelar",
          role: "cancel",
        },
      ]}
    />
  );
};

export default React.memo(CameraActionSheet);
